/// <reference path='../_all.ts' />



module editor {
  'use strict';

  ///Andere Sicht auf Ressourcen, einfacher als Tabelle darstellbar.
  export interface IRessourceTableData {
    [key: string]: IRessourceTableRow;
  }

  export interface IRessourceTableRow {
    Key : string;
    Scope : string;
    Desc: string;    
    Text : IRessourceTableRowLanguage;
  }

  export interface IRessourceTableRowLanguage {
    [hl: string] : string;
  }


}